function EmptyOffenderAbsenceSchedule() {
    this.__type = 'OffenderAbsenceSchedule:www.veritracks.com';
    this.Id = -1;
    this.Reason = '';
    this.EnrolleeId = -1;
    this.IsFriday = '';
    this.IsMonday = '';
    this.IsSaturday = '';
    this.IsSunday = '';
    this.IsThursday = '';
    this.IsTuesday = '';
    this.IsWednesday = '';
    this.StartDate = '';
    this.StartTime = '';
    this.StopTime = '';
    this.IsActive = '';
    this.IsRecurring = false;
    this.ScheduleTypeId = -1;
    this.EntityId = -1;
    this.EntityName = '';
    this.ZoneScheduleType = -1;
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
    this.TitleUpdatedFlag = '';
    this.MonScheduleId = -1;
    this.TueScheduleId = -1;
    this.WedScheduleId = -1;
    this.ThuScheduleId = -1;
    this.FriScheduleId = -1;
    this.SatScheduleId = -1;
    this.SunScheduleId = -1;
}
if (typeof exports !== 'undefined') {
    module.exports = EmptyOffenderAbsenceSchedule;
}